<template>
    <li :class="rootClass">
        <em class="ico_cafe ico_reply">답글</em>
        <a class="link_group" :class="CAT" :href="linkUrl">
            <template v-if="!article.dummy">
                <strong class="tit_group">{{ title }}</strong><span class="num_cmt" v-if="hasComment"><span class="sr_only">댓글</span>(<span class="num_placeholder">{{ article.commentCount }}</span>)</span>
            </template>
        </a>
    </li>
</template>

<script>
export default {
    props: {
        article: Object,
        config: Object
    },
    computed: {
        svcParam() {
            return this.config.svcParam;
        },
        isValidCode() {
            return this.config.isValidCode;
        },
        listURI() {
            return this.config.listURI;
        },
        rootClass() {
            return {
                on: this.article.current,
                reply_on: parseInt(this.article.parid) > 0,
                reply_off: this.article.dummy || !this.article.parid || parseInt(this.article.parid) === 0
            }
        },
        title() {
            if (!this.article.name) {
                return '';
            }
            return this.article.name.replace(/\\"/g, '"');
        },
        hasComment() {
            return this.article.commentCount > 0;
        },
        baseUrl() {
            return `/${this.article.grpcode}/${this.article.fldid}/${this.article.dataid}`;
        },
        linkUrl() {
            let url = this.baseUrl;
            if (this.isValidCode) {
                url += `?svc=${this.svcParam === 'daumapp' ? 'topRank' : this.svcParam}`;
            } else {
                url += `?listURI=${this.listURI || encodeURIComponent('/' + this.article.grpcode + '/' + this.article.fldid)}`;
            }
            return url;
        },
        CAT() {
            return `?c_id=${encodeURIComponent(this.baseUrl)}&c_source=${this.article.grpcode}&c_ch=${this.svcParam}&c_title=${encodeURIComponent(this.title)}`;
        }
    }
}
</script>
